import { type ChangeEvent, useState } from 'react';
import { useAppDispatch } from '../../../../../configuration/setup/hooks';
import { useCreatePartnerIntegrationMutation } from '../../../../services/partnerIntegrationApi';
import {
    setAccountId,
    setAccountName,
    setClientId,
    useAccountId,
    useClientId,
    useStatus,
} from '../partnerIntegrationSlice';
import { useLazyGetAccountNameByIdQuery } from '../../../../services/accountsApi';

export const CreatePartnerIntegration = () => {
    const accountId = useAccountId();
    const clientId = useClientId();
    const status = useStatus();

    const [accountIdModified, setAccountIdModified] = useState(false);

    const [createPartnerIntegration] = useCreatePartnerIntegrationMutation();
    const [fetchAccountName] = useLazyGetAccountNameByIdQuery();

    const dispatch = useAppDispatch();

    const canCreate = status !== 'pending' && accountId && clientId;

    const onChangeAccountId = (evt: ChangeEvent<HTMLInputElement>) => {
        setAccountIdModified(true);
        dispatch(setAccountId(evt.currentTarget.value));
    };

    const onChangeClientId = (evt: ChangeEvent<HTMLInputElement>) => dispatch(setClientId(evt.currentTarget.value));

    const onLeaveAccountId = () => {
        if (accountIdModified && accountId) {
            fetchAccountName(accountId)
                .unwrap()
                .then(accountName => dispatch(setAccountName(accountName)));
            setAccountIdModified(false);
        }
    };

    return (
        <fieldset>
            <div className='form-group'>
                <label htmlFor='accountID' className='control-label'>
                    Account-ID
                </label>
                <input
                    value={accountId}
                    onFocus={() => setAccountIdModified(false)}
                    onBlur={onLeaveAccountId}
                    onChange={onChangeAccountId}
                    type='text'
                    className='form-control'
                    id='accountID'
                    placeholder='Account-ID'
                />
            </div>
            <div className='form-group'>
                <label htmlFor='clientID' className='control-label'>
                    Client-ID
                </label>
                <input
                    value={clientId}
                    onChange={onChangeClientId}
                    type='text'
                    className='form-control'
                    id='clientID'
                    placeholder='Client-ID'
                />
            </div>
            <div className='btn-toolbar margin-top-20'>
                {status === 'pending' ? (
                    <button type={'button'} className='btn btn-primary btn-loading-overlay disabled'>
                        Create
                    </button>
                ) : (
                    <button
                        type={'button'}
                        onClick={() => createPartnerIntegration({ accountId, clientId })}
                        className={`btn btn-primary ${canCreate ? '' : 'disabled'}`}
                    >
                        Create
                    </button>
                )}
            </div>
        </fieldset>
    );
};
